<template>
  <div :class="{'has-logo':showLogo}">
    <logo :collapse="isCollapse"/>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
          :active-text-color="variables.menuActiveText"
          :background-color="variables.menuBg"
          :collapse="isCollapse"
          :collapse-transition="false"
          :default-active="activeMenu"
          :text-color="variables.menuText"
          :unique-opened="true"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :base-path="route.path" :item="route"/>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Logo from './Sidebar/Logo'
import SidebarItem from './Sidebar/SidebarItem'
import variables from '@/styles/variables.scss'
import {getMenuTheme} from '@/utils/theme'

export default {
  components: {SidebarItem, Logo},
  computed: {
    ...mapGetters([
      'sidebar',
      'theme',
    ]),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      //默认菜单
      const route = this.$route;
      const {meta, path} = route;
      // 如果设置路径，侧栏将突出显示您设置的路径
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      const menuTheme = getMenuTheme(this.theme)
      return {
        ...variables,
        menuBg: menuTheme.menuBg,
        menuText: menuTheme.menuText,
        menuActiveText: menuTheme.menuActiveText,
        subMenuBg: menuTheme.subMenuBg,
      }
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
